import { Col, message, Row, Space, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { TelegramShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import CopyLinkIcon from "../../assets/icons/fan/shareModal/copy-link.svg";
import MessageIcon from "../../assets/icons/fan/shareModal/message.svg";
import TelegramIcon from "../../assets/icons/fan/shareModal/telegram.svg";
import TwitterIcon from "../../assets/icons/fan/shareModal/twitter.svg";
import WhatsAppIcon from "../../assets/icons/fan/shareModal/whatsapp.svg";
import { copyToClipboard, isMobile } from "../../utls/FunctionsUtil";
import "./index.less";

type props = {
  isOpen: boolean;
  onClose: () => void;
  id?: string;
  link?: string;
  username?: string;
  headerTitle?: string;
};

const ShareModalComponent: React.FC<props> = ({ isOpen, onClose, id, link, username, headerTitle }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const url = link !== undefined ? link : `${window.location.origin}/p/${username}`;

  const copyClipBoardClicked = async () => {
    await copyToClipboard(url);
    await message.success(t("link-copied"));
  };

  const openSMSApp = () => {
    if (isMobile()) {
      const encodedMessage = encodeURIComponent(url);
      window.location.href = `sms:?body=${encodedMessage}`;
    }
  };

  const socialLinks = [
    {
      name: "WhatsApp",
      element: (
        <Col key={1} className="d-contents justify-content-center" span={6}>
          <WhatsappShareButton
            url={url}
            children={
              <Space className="gap-2" direction="vertical" align="center">
                <img src={WhatsAppIcon} alt="whatsapp icon" className="share-modal-icon" />
                <Typography.Text className="shareModalSocialLinkLabel">{t("whatsapp")}</Typography.Text>
              </Space>
            }
          />
        </Col>
      ),
    },
    {
      name: "Twitter",
      element: (
        <Col key={2} className="d-contents justify-content-center" span={6}>
          <TwitterShareButton
            url={url}
            children={
              <Space className="gap-2" direction="vertical" align="center">
                <img src={TwitterIcon} alt="twitter icon" className="share-modal-icon" />
                <Typography.Text className="shareModalSocialLinkLabel">{t("twitter")}</Typography.Text>
              </Space>
            }
          />
        </Col>
      ),
    },
    {
      name: "Telegram",
      element: (
        <Col key={3} className="d-contents justify-content-center" span={6}>
          <TelegramShareButton
            url={url}
            children={
              <Space className="gap-2" direction="vertical" align="center">
                <img src={TelegramIcon} alt="telegram icon" className="share-modal-icon" />
                <Typography.Text className="shareModalSocialLinkLabel">{t("telegram")}</Typography.Text>
              </Space>
            }
          />
        </Col>
      ),
    },
    {
      name: "Message",
      element: (
        <Col key={4} className="d-contents justify-content-center" span={6}>
          <Space className="gap-2 cursor-pointer" direction="vertical" align="center" onClick={openSMSApp}>
            <img src={MessageIcon} alt="message icon" className="share-modal-icon" />
            <Typography.Text className="shareModalSocialLinkLabel">{t("message")}</Typography.Text>
          </Space>
        </Col>
      ),
    },
    {
      name: "Copier le lien",
      element: (
        <Col key={5} className="d-contents justify-content-center" span={6}>
          <Space className="gap-2 cursor-pointer" direction="vertical" align="center" onClick={copyClipBoardClicked}>
            <img src={CopyLinkIcon} alt="copy icon" className="share-modal-icon" />
            <Typography.Text className="shareModalSocialLinkLabel">{t("copy-link")}</Typography.Text>
          </Space>
        </Col>
      ),
    },
  ];

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleOverlayClick}></div>
        </Row>
        <div className="bottom-modal-header">
          <Typography.Text className="bottom-modal-title">{t("share-profile")}</Typography.Text>
        </div>
        <div className="social-items-row">
          <Row className="social-items-container" gutter={8}>
            {socialLinks.map((item) => {
              return item.element;
            })}
          </Row>
        </div>
        <div className="bottom-modal-body mt-10">
          <button className="bottom-modal-cancel-button mt-0" onClick={onClose}>
            <Typography.Text className="bottom-modal-cancel-button-title">{t("cancel")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModalComponent;
